import { render, staticRenderFns } from "./ProjectViewGateReport.vue?vue&type=template&id=58444a4a&scoped=true&"
import script from "./ProjectViewGateReport.vue?vue&type=script&lang=js&"
export * from "./ProjectViewGateReport.vue?vue&type=script&lang=js&"
import style0 from "./ProjectViewGateReport.vue?vue&type=style&index=0&id=58444a4a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58444a4a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VImg } from 'vuetify/lib/components/VImg';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VDialog,VDivider,VIcon,VImg,VRow,VSpacer})
